import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddCourse from "../../../containers/superadmin/courses/models/add-course";
import SearchBar from "../../../containers/superadmin/courses/searchbar";
import CoursesTable from "../../../containers/superadmin/courses/table";
import { getAllCoursesRequest } from "../../../modules/superadmin-modules/courses/Actions";

const Courses = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    dispatch(getAllCoursesRequest());
  }, []);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setSelectedData={setSelectedData} />
      <CoursesTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddCourse
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default Courses;
